const Header = () => {
  return (
    <nav className='nav-wrapper blue-grey'>
      <div className='header-text'>COVID-19 DASHBOARD</div>
    </nav>
  );
}

export default Header;